// this code is to be used until ticket LIT-498669 is resolved
import Base from '../../ts/_base';

export default class Metrics extends Base {

    private metricTextCont: HTMLElement;
    private merticsBtn: NodeListOf<HTMLElement>;
    private merticsBtnMon: HTMLElement;
    private merticsBtnYear: HTMLElement;
    private metricsPreText: HTMLElement;
    private metricsToolbar: HTMLElement;

    get ChildSelectors(): { [key: string]: string } {
        return {
            ...this.selectors,
            metricstext: '#tab-metrics-inner .period-note',
            merticsBtn: '.metrics-tabs__item .metrics-tabs__item-link',
            merticsBtnMon: '.metrics-tabs__item [data-title="last6"]',
            merticsBtnYear: '.metrics-tabs__item [data-title="last12"]',
            metricsToolbar: '.toolbar-metric .menu-title--downloads .menu-title-text'
        }
    }
    public initialize(): void {
        const config = { attributes: true, childList: true, subtree: true };
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                    if(mutation.target.classList[0] == 'sidebar-metric__content-section'){
                        this.set();
                        this.controller();
                        observer.disconnect();
                        return true;
                    }
                    else if(mutation.target.classList[0] == 'total-text'){
                        this.setToolbarMetricsText();
                        observer.disconnect();
                        return true;
                    }
                }
            }
        };
        const sidebarMetrics = document.querySelector('.sidebar-metric-container');
        if (sidebarMetrics) {
            const observer = new MutationObserver(callback);
            observer.observe(sidebarMetrics, config);
        }
        const toolbarMetrics = document.querySelector('.toolbar-metric-container')
        if (toolbarMetrics) {
            const observer2 = new MutationObserver(callback);
            observer2.observe(toolbarMetrics, config);
        }
    }
    protected set(): void {
        this.metricTextCont = this.queryElm(this.ChildSelectors.metricstext) as HTMLElement;
        this.merticsBtn = this.queryElm(this.ChildSelectors.merticsBtn, true) as NodeListOf<HTMLElement>;
        this.merticsBtnMon = this.queryElm(this.ChildSelectors.merticsBtnMon) as HTMLElement;
        this.merticsBtnYear = this.queryElm(this.ChildSelectors.merticsBtnYear) as HTMLElement;
    }
    protected controller(): void {
        this.setpostText();
    }
    protected setpostText(): void {
        if (this.metricTextCont && this.metricTextCont.innerHTML === 'for the most recent 6 months whole calendar months.') {
            this.metricTextCont.innerHTML = 'for the most recent 6 whole calendar months.'
        }
        if (this.merticsBtnMon) {
            this.merticsBtnMon.addEventListener('click', () => {
                this.metricTextCont.innerHTML = 'for the most recent 6 whole calendar months.'
            });
        }
        if (this.merticsBtnYear) {
            this.merticsBtnYear.addEventListener('click', () => {
                this.metricTextCont.innerHTML = 'for the most recent 12 whole calendar months.'
            });
        }
    }

    protected setToolbarMetricsText() {
        this.metricsToolbar = this.queryElm(this.ChildSelectors.metricsToolbar) as HTMLElement;
        let toolbarMetricsText: string = this.metricsToolbar.innerHTML;
        if (toolbarMetricsText && toolbarMetricsText.toLowerCase() === 'total downloads') {
            this.metricsToolbar.innerHTML = 'Total Views';
        }
    }
}